<template>
<div>
  <div class="row">
    <div class="col-xs-12 col-md-3 col-md-offset-3">
      <div style="border: 1px solid #C2CAD8; padding: 1em; margin-bottom: 1em;">
        <div class="ss-titre">
            <strong>Etape 1 : Enregistrer son ID de suivi</strong>
        </div>
        <div class="portlet-body">
          <div class="portlet light">
            <v-input type="text" name="ga_tracking_id" title="Analytics tracking ID" placeholder="Exemple : UA-138316348-1" v-model="ga_tracking_id"></v-input>
            <a class="btn btn-block btn-primary" href="/pdf/analytics/IDsuivi.pdf" target="_blank">Obtenir son ID de suivi</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-3 ">
      <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
        <div class="ss-titre">
            <strong>Etape 2 : Enregistrer son ID de vue</strong>
        </div>
        <div class="portlet-body">
          <div class="portlet light">
            <v-input type="text" name="ga_view_id" title="Analytics view ID" placeholder="Exemple : 193457112" v-model="ga_view_id"></v-input>
            <a class="btn btn-block btn-primary" href="/pdf/analytics/IDvue.pdf" target="_blank">Obtenir son ID de vue</a>
          </div>
        </div>
      </div>
    </div>
  </div>
    <div class="row">
    <div class="col-md-6 col-md-offset-3">
      <button  class="btn-block btn green" @click="send" :disabled="ga_view_id == '' || ga_tracking_id == '' ? true : false">Valider les identifiants</button>
    </div>
  </div>
  <!-- <div v-if="errors[0].message">
    {{errors[0].message}}
  </div> -->
</div>
</template>
<script>
export default {
  name: 'OfficeAnalytics',
  props: {
    office: {
      type: Object,
      default: () => {
        return {}
      }
    },
    errors: {
      type: [Object, Number],
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      urlHash: window.location.origin + window.location.pathname + '#tab_1_8',
      ga_view_id: this.office.ga_view_id,
      ga_tracking_id: this.office.ga_tracking_id
    }
  },
  methods: {
    async send() {
      this.office.ga_view_id = this.ga_view_id
      this.office.ga_tracking_id = this.ga_tracking_id
      await axios.put(`/office/${this.office.id}`, this.office)
      window.setTimeout(window.location = this.urlHash, 400)
      window.setTimeout(window.location.reload.bind(window.location), 500)
      this.$snotify.success('informations générales mises a jour')
    },
  }
}
</script>

<style lang="css" scoped>

</style>
